import React from 'react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Tooltip,
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import MUIDataTable from 'mui-datatables';
import './styles/dialog.css';
import './styles/devicesview.css';
import { withTranslation } from 'react-i18next';
import iconNosignal from '../../images/Presense/DeviceSignal/icon-nosignal.png';
import { getTimeFormatted } from '../../utils/timeFormatted';

class StatusView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.props.state;
  }

  battery = (level, timestamp) => {
    const { classes, t } = this.props;
  
    // Define the battery level thresholds and corresponding icons
    const batteryLevels = [
      { max: 20, icon: <Icons.BatteryAlert className={classes.iconWarning} /> },
      { max: 40, icon: <Icons.Battery30 color='primary' /> },
      { max: 50, icon: <Icons.Battery50 color='primary' /> },
      { max: 70, icon: <Icons.Battery60 color='primary' /> },
      { max: 80, icon: <Icons.Battery80 color='primary' /> },
      { max: 90, icon: <Icons.Battery90 color='primary' /> },
      { max: Infinity, icon: <Icons.BatteryFull color='primary' /> },
    ];
  
    // Find the appropriate battery icon based on the level
    const batteryIcon = batteryLevels.find(({ max }) => level <= max)?.icon;
  
    // Return the Tooltip component with the correct battery icon
    return (
      <Tooltip
        title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
        classes={{ tooltip: classes.tooltipFont }}
      >
        {batteryIcon}
      </Tooltip>
    );
  };
  
  // battery = (level, timestamp) => {
  //   const { classes, t } = this.props;
  //   let result = '';
  //   if (level > 0 && level <= 20) {
  //     result = (
  //       <Tooltip
  //         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(timestamp, t) + ')'}
  //         classes={{ tooltip: classes.tooltipFont }}
  //       >
  //         <Icons.BatteryAlert className={classes.iconWarning} />
  //       </Tooltip>
  //     );
  //   } else if (level > 20 && level <= 40) {
  //     result = (
  //       <Tooltip
  //         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(timestamp, t) + ')'}
  //         classes={{ tooltip: classes.tooltipFont }}
  //       >
  //         <Icons.Battery30 color='primary' />
  //       </Tooltip>
  //     );
  //   } else if (level > 40 && level <= 50) {
  //     result = (
  //       <Tooltip
  //         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(timestamp, t) + ')'}
  //         classes={{ tooltip: classes.tooltipFont }}
  //       >
  //         <Icons.Battery50 color='primary' />
  //       </Tooltip>
  //     );
  //   } else if (level > 50 && level <= 70) {
  //     result = (
  //       <Tooltip
  //         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(timestamp, t) + ')'}
  //         classes={{ tooltip: classes.tooltipFont }}
  //       >
  //         <Icons.Battery60 color='primary' />
  //       </Tooltip>
  //     );
  //   } else if (level > 70 && level <= 80) {
  //     result = (
  //       <Tooltip
  //         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(timestamp, t) + ')'}
  //         classes={{ tooltip: classes.tooltipFont }}
  //       >
  //         <Icons.Battery80 color='primary' />
  //       </Tooltip>
  //     );
  //   } else if (level > 80 && level <= 90) {
  //     result = (
  //       <Tooltip
  //         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(timestamp, t) + ')'}
  //         classes={{ tooltip: classes.tooltipFont }}
  //       >
  //         <Icons.Battery90 color='primary' />
  //       </Tooltip>
  //     );
  //   } else if (level > 90) {
  //     result = (
  //       <Tooltip
  //         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(timestamp, t) + ')'}
  //         classes={{ tooltip: classes.tooltipFont }}
  //       >
  //         <Icons.BatteryFull color='primary' />
  //       </Tooltip>
  //     );
  //   }
  //   return result;
  // };

  isEmergencyButton = (devices) => {
    for (const device of devices || []) {
      const { deviceVersion } = device;
      if (deviceVersion) {
        const property = deviceVersion.property ? JSON.parse(deviceVersion.property) : null;
        if (property) {
          if (property.alarmTrigger || property.alarmOnoff) {
            return true;
          }
        }
      }
    }
    return false;
  };

  isEmergencyDevice = (deviceVersion) => {
    // const { deviceVersion } = device;
    if (deviceVersion) {
      const property = deviceVersion.property ? JSON.parse(deviceVersion.property) : null;
      if (property) {
        if (property.alarmTrigger || property.alarmOnoff) {
          return true;
        }
      }
    }
    return false;
  };
  getFullname = (language, data) => {
    let fullname = '';
    if (language && language === 'th-TH') {
      if (data.firstname || data.lastname) {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      } else {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      }
    }

    if (language && language === 'en-EN') {
      if (data.firstnameEn || data.lastnameEn) {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      } else {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      }
    }

    return fullname;
  };

  render() {
    let { t, data, open, classes } = this.props;

    const columns = [
      {
        name: 'id',
        label: 'ID',
        options: {
          display: false,
        },
      },
      {
        name: 'name',
        label: `${t('device_name')}`,
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'action',
        label: `${t('action')}`,
        options: {
          display: false,
          filter: false,
          sort: false,
        },
      },
      {
        name: 'deviceVersion',
        label: `${t('type')}`,
        options: {
          display: false,
          filter: false,
          sort: false,
        },
      },
      {
        name: 'status',
        label: `${t('status')}`,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            // row[2] is action
            const batteryTimestamp =
              row[2] && row[2].batteryTimestamp ? row[2].batteryTimestamp : row[2] && row[2].timestamp;
            if (row && row[2]) {
              return (
                <div className={this.props.classes.columnWidth200}>
                  {(!this.isEmergencyDevice(row && row[3]) && row[4] === 'ACTIVATE_OFF') ||
                  row[2].alertType === 504 ||
                  row[2].alertType === 513 ||
                  row[2].nosignal === 'true' ||
                  (row[2].changed && row[2].changed.a === null && row[4] === 'ACTIVATE_ON') ? (
                    <img src={iconNosignal} alt='nosignal' width='30' title={getTimeFormatted(row[2].alertTime, t)} />
                  ) : row && row[2] ? (
                    row[2].changed && row[2].changed.b ? (
                      this.battery(row[2].changed && row[2].changed.b, batteryTimestamp)
                    ) : (
                      <Tooltip title={t('signal')} classes={{ tooltip: classes.tooltipFont }}>
                        <Icons.Wifi color='primary' />
                      </Tooltip>
                    )
                  ) : (
                    ''
                  )}
                </div>
              );
            } else {
              return (
                <div className={this.props.classes.columnWidth200}>
                  {row && (row[4] === 'ACTIVATE_OFF' || row[4] === 'ACTIVATE_ON') && (
                    <img src={iconNosignal} alt='nosignal' width='30' />
                  )}
                </div>
              );
            }
          },
        },
      },
    ];

    return (
      <Dialog
        open={open}
        onClose={this.props.setCloseStatus}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle className='header' id='form-dialog-title'>
          {t('device_status_for')}{' '}
          <span className='headerMain'>{this.getFullname(localStorage.getItem('i18nextLng'), data.patient)}</span>
        </DialogTitle>
        <DialogContent style={{ height: '300px' }}>
          <Grid container item xs={12}>
            <Grid item xs={12}>
              <MUIDataTable
                data={data.patient.devices || []}
                columns={columns}
                searchable={false}
                options={{
                  viewColumns: false,
                  filter: false,
                  sort: false,
                  download: false,
                  print: false,
                  pagination: false,
                  selectableRowsOnClick: false,
                  selectableRows: 'none',
                  searchable: false,
                  search: false,
                  responsive: 'scrollFullHeight',
                  rowsPerPage: 5,
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.setCloseStatus} color='default' id='cancel'>
            {t('cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export const translation = withTranslation()(StatusView);
export default withStyles({ withTheme: true })(translation);
